import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResourceHandler } from '@ngx-resource/core';
import { ResourceHandlerHttpClient } from './src/ResourceHandlerHttpClient';
import * as ɵngcc0 from '@angular/core';
export * from './src/ResourceHandlerHttpClient';
var ResourceModule = /** @class */ (function () {
    function ResourceModule() {
    }
    /**
     * For root
     * @param {IResourceModuleConfig} config
     * @return {ModuleWithProviders}
     */
    ResourceModule.forRoot = function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: ResourceModule,
            providers: [
                config.handler || { provide: ResourceHandler, useClass: ResourceHandlerHttpClient, deps: [HttpClient] }
            ]
        };
    };
    /**
     * For child
     * @param {IResourceModuleConfig} config
     * @return {ModuleWithProviders}
     */
    ResourceModule.forChild = function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: ResourceModule,
            providers: [
                config.handler || { provide: ResourceHandler, useClass: ResourceHandlerHttpClient, deps: [HttpClient] }
            ]
        };
    };
ResourceModule.ɵfac = function ResourceModule_Factory(t) { return new (t || ResourceModule)(); };
ResourceModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ResourceModule });
ResourceModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResourceModule, [{
        type: NgModule
    }], function () { return []; }, null); })();
    return ResourceModule;
}());
export { ResourceModule };

